module.exports = __webpack_public_path__ + "img/accessory_shirt_13.355d2b34.svg";